import { config } from 'data';
import { statisticsService } from 'services';
import { useQuery } from 'hooks';
import { StatisticsFeesParams } from 'types/services';

const useStatisticsFeesQuery = (params: StatisticsFeesParams) => useQuery({
  queryKey: [config.STATISTICS_FEES_QUERY_KEY, params],
  queryFn: () => statisticsService.getFees(params),
});

export default useStatisticsFeesQuery;
